// @ts-check

import { api } from '@/api'

/**
 * Forms vehicle API route for the specified company and vehicle id.
 * @param {Id} companyId
 * @param {?Id} [vehicleId=null]
 * @returns {string} API route for the specified company and vehicle id.
 */
const getEndpoint = (companyId, vehicleId = null) => {
  let endpoint = `company/${companyId}/vehicles`

  if (vehicleId) {
    endpoint += `/${vehicleId}`
  }

  return endpoint
}

/**
 * Fetches company vehicle with the given id from the API.
 * @param {Id} companyId
 * @param {Id} vehicleId
 * @returns {Promise<import('axios').AxiosResponse<VehicleResource>>}
 */
export const getVehicle = async (companyId, vehicleId) =>
  api.get(`${getEndpoint(companyId, vehicleId)}`)

/**
 * Fetches all company vehicles from the API.
 * @param {Id} companyId
 * @returns {Promise<import('axios').AxiosResponse<VehicleResource[]>>}
 */
export const getVehicles = async (companyId) => api.get(getEndpoint(companyId))

/**
 * Creates new company vehicle through the API.
 * @param {number} companyId
 * @param {Partial<VehicleResource>} vehicleData
 * @returns {Promise<import('axios').AxiosResponse<VehicleResource>>}
 */
export const createVehicle = async (companyId, vehicleData) =>
  api.post(getEndpoint(companyId), vehicleData)

/**
 * Updates company vehicle details with the given id.
 * @param {number} companyId
 * @param {number} vehicleId
 * @param {Partial<VehicleResource>} vehicleData
 * @returns {Promise<import('axios').AxiosResponse<VehicleResource>>}
 */
export const updateVehicle = async (companyId, vehicleId, vehicleData) =>
  api.put(getEndpoint(companyId, vehicleId), vehicleData)

/**
 *
 * @param {number} companyId
 * @param {number} vehicleId
 * @param {Partial<VehicleResource>} removalData
 * @returns {Promise<import('axios').AxiosResponse<VehicleResource>>}
 */
export const addVehicleToRemoval = async (companyId, vehicleId, removalData) =>
  api.post(`${getEndpoint(companyId, vehicleId)}/removal`, removalData)
